import { useState, useMemo } from 'react';

type currentTimeT = `${string}:${string}:${string}`;

type paramsT = {
  date: string;
};

const getTime = (param: number): currentTimeT => {
  const h = Math.floor(param / (1000 * 60 * 60));
  const m = Math.floor((param - h * 1000 * 60 * 60) / (1000 * 60));
  const s = Math.floor((param - h * 1000 * 60 * 60 - m * 1000 * 60) / 1000);

  const hours = h < 10 ? `0${h}` : `${h}`;
  const minutes = m < 10 ? `0${m}` : `${m}`;
  const seconds = s < 10 ? `0${s}` : `${s}`;

  return `${hours}:${minutes}:${seconds}`;
};

export const useTimer = ({ date }: paramsT) => {
  const paramDate = new Date(date).getTime();
  const [currentTime, setCurrentTime] = useState<currentTimeT>(getTime(Math.abs(Date.now() - paramDate)));
  const [isCountdownEnded, setIsCountdownEnded] = useState<boolean>(false);

  const { stopTimer } = useMemo(() => {
    const timer = setInterval(function () {
      const now: number = Date.now();
      const distance: number = Math.abs(now - paramDate);

      if (paramDate < now) {
        // timer
        setCurrentTime(getTime(distance));
      } else {
        // countdown
        if (distance < 1000) {
          setIsCountdownEnded(true);
          clearInterval(timer);
        } else {
          setCurrentTime(getTime(distance));
        }
      }
    }, 1000);

    const stopTimer = () => {
      clearInterval(timer);
    };

    return { stopTimer };
  }, [paramDate]);

  return { currentTime, stopTimer, isCountdownEnded };
};
